import styled  from "styled-components";


export const Section = styled.section`
background-color: ${props => props.theme.backgroundColorNavFooter};
  width: 100%;
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;

 button {
  background-color: ${props => props.theme.siteColor};
  color: ${props => props.theme.textColor};
  width: 180px;
  padding: 10px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.5s;
  font-size: 15px;
}

 button:hover {
  background-color: ${props => props.theme.hover};
}

@media screen and (max-width: 505px) {
h2{
  font-size: 25px;
}
}
@media screen and (max-width: 430px) {
h2{
  font-size: 20px;
}
button{
  
  width: 150px;
}

}
@media screen and (max-width: 350px) {
  h2{
  font-size: 18px;
}
button{
  
  width: 120px;
}

}



`